import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../public/img/ZBEdge-lightbg.svg'
import _imports_1 from '../../public/img/Zimmer-Biomet-logo.svg'


const _withScopeId = n => (_pushScopeId("data-v-4ed6339e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "max-page-width-nav container navbar navbar-expand-sm navbar-toggleable-sm navbar-light" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "navbar-toggler-icon" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  src: _imports_1
}
const _hoisted_7 = { class: "navbar-nav flex-grow-1" }
const _hoisted_8 = {
  key: 0,
  class: "nav-item"
}
const _hoisted_9 = {
  key: 1,
  class: "nav-item dividerWrap"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header-hr text-dark" }, " | ", -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  key: 2,
  class: "nav-item"
}
const _hoisted_13 = ["href"]
const _hoisted_14 = {
  key: 3,
  class: "nav-item"
}
const _hoisted_15 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", null, [
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_link, {
          id: "logoWrap",
          class: "navbar-brand",
          to: _ctx.isApp == false ? {name:'Dashboard'} : {}
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["to"]),
        (_ctx.IsLoggedIn)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.collapsed=!_ctx.collapsed)),
              class: "navbar-toggler",
              type: "button",
              "aria-controls": "navbarSupportedContent",
              "aria-expanded": "false",
              "aria-label": "Toggle navigation"
            }, _hoisted_5))
          : _createCommentVNode("", true),
        (!_ctx.IsLoggedIn)
          ? (_openBlock(), _createElementBlock("img", _hoisted_6))
          : _createCommentVNode("", true),
        (_ctx.authenticationRequired == false)
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: _normalizeClass([{ collapse: _ctx.collapsed }, "navbar-collapse d-sm-inline-flex justify-content-between"])
            }, [
              _createElementVNode("ul", _hoisted_7, [
                (_ctx.IsLoggedIn)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_8, [
                      _createVNode(_component_router_link, {
                        class: "nav-link text-dark",
                        to: {name:'EditProfilePage'}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.FullName), 1)
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.IsLoggedIn)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_9, _hoisted_11))
                  : _createCommentVNode("", true),
                (_ctx.IsLoggedIn)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_12, [
                      _createElementVNode("a", {
                        class: "nav-link text-dark",
                        href: _ctx.FixProxyAuthUrl('/logout')
                      }, _toDisplayString(_ctx.$t('sign_out')), 9, _hoisted_13)
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.IsLoggedIn && _ctx.authenticationRequired == false)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_14, [
                      _createElementVNode("a", {
                        class: "nav-link text-dark",
                        href: _ctx.FixProxyAuthUrl('/login')
                      }, _toDisplayString(_ctx.$t('sign_in')), 9, _hoisted_15)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ], 2))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}